module.exports = __webpack_public_path__ + "media/images/pack-04-735c1342cd1384fbc73ba70ca78108c0.jpg";